import {React} from "react";
import Chart from "react-apexcharts";

const CategoricalBarChart = ({dataSeries,colores,loading}) => {
  
  const options = {
    states: {
      hover: {
          filter: {
              type: 'darken',
              value: 0.8,
          }
      },
    },
    legend: {
      show: false
    },
    noData: {
      text: loading?"Cargando ..." : "No hay datos",
      offsetX: 70,
      offsetY: -20,
      style: {
        color: "#2f4554"/* "#00b7c4" */,
        fontSize: '14.4px',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      }
    },
    grid: {
      position: 'back'
    },
    colors: colores,
    chart: {
      toolbar:{show:false},
      defaultLocale: 'en',
      locales: [{
        name: 'en',
        options: {
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          days: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
          shortDays: ['Dom','Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
          toolbar: {
            download: 'Descargar SVG',
            selection: 'Selección',
            selectionZoom: 'Selección Zoom',
            zoomIn: 'Zoom',
            zoomOut: 'Alejar',
            pan: 'Panning',
            reset: 'Reset Zoom',
          }
        }
      }],
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",/* `${(100/dataSeries.categorias.length)}%` */
        colors: {
          backgroundBarColors: dataSeries?.categorias.map(() => "#f5f5f5")//["#f5f5f5"],                               
        }
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: dataSeries?.categorias,
      labels:{
        style: {
          fontWeight: "bold",
      },
      }
    },
    yaxis: [
      {
        labels: {
          formatter: function(val) {
            return `${Math.floor(val)}`
          }
        },
        min: 0,
        max: dataSeries.vueltas.length > 0 ? Math.max(...dataSeries.vueltas) + 2 : 5,
      },
      {
        labels: {
          formatter: function(val) {
            return `${Math.floor(val)}`
          }
        },
        opposite: true,
        min: 0,
        max: dataSeries.toneladas.length > 0 ? Math.max(...dataSeries.toneladas) + 2 : 5 //Math.max(...dataSeries.toneladas),
      }
    ],
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val}`
        }
      }
    }
  };
  
  return (
    <div id="chartbar">
      <Chart 
        height={"250px"} 
        width={"100%"} 
        options={options} 
        series={[{name: "Vueltas",data: dataSeries?.vueltas},{name:"Toneladas",data :dataSeries?.toneladas}]} 
        type="bar" 
      />
    </div>
  );
  
}

export default CategoricalBarChart;